import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginAppService } from './login-app.service';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogeComponent } from '../dialoge/dialoge.component';
import { Router } from '@angular/router';
interface UserData {
  EmailId: string;
  Password: string;
  // Add other properties as needed
}

@Component({
  selector: 'app-login-app',
  templateUrl: './login-app.component.html',
  styleUrls: ['./login-app.component.css']
})
export class LoginAppComponent {
  LoginDetails: FormGroup | any;
  isFormSubmitted = false;
  loginDetails: any = [];
  alertVisible:boolean=false;

  constructor(private loginAppService: LoginAppService,
    private fb: FormBuilder,
    private router: Router
    ) {
      this.LoginDetails = new FormControl('', [
        Validators.required,
        Validators.email
      ]);
  }
  validUser:any
  
  ngOnInit(){
    localStorage.clear();
  }

  onsubmit() {
    // console.log('LoginDetails:' + this.LoginDetails) 
    if (this.LoginDetails.valid) {
      if (this.LoginDetails) {
        // console.log('res email:' + this.LoginDetails.value.email)  
        this.loginAppService.getUserMasterDetails(this.LoginDetails.value).subscribe((res: any) => {
          this.loginDetails = res.data
          //  console.log('res Data:' + res.data)  
          localStorage.setItem('loginDetails', JSON.stringify(this.loginDetails));
          this.validUser = this.loginDetails.find((user: any) =>
            user.email.toLowerCase() === this.LoginDetails.value.toLowerCase()

          );
          //  console.log('this.validUser:' + this.validUser)
          //  console.log(this.loginDetails)
          if (this.validUser) {
            // console.log('User Is Valid') 
            this.router.navigate(['/timesheet']);
          }
          else {
            this.alertVisible = true;
          }
        });
      }
    } else {
      this.alertVisible = true;
    }
  }
}
